'use strict';

function CompanyPublicationKeypassService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/:publicationId/keypass', {}, {
    'update': {
      method: 'POST'
    }
  });
}

angular.module('dokiv')
  .factory('CompanyPublicationKeypassService', ['$resource', 'config', CompanyPublicationKeypassService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationKeypassService.js
// module id = 61
// module chunks = 0